import React, { useState } from 'react';

import classes from './DefaultMessage.module.scss';

import ConfigureViewModel from 'components/home/views/configure-view/ConfigureViewModel';
import { VIEW } from 'constants/constants';

const DefaultMessage = ({ page }) => {
  const [modalShow, setModalShow] = useState(false);

  return (
    <div className={classes.defaultMessage}>
      <p className={classes.defaultMessageText}>
        Add tiles to this view with{' '}
        <span
          onClick={() => setModalShow(true)}
          className='link'>
          Configure My View
        </span>{' '}
      </p>
      <ConfigureViewModel
        show={modalShow}
        onHide={() => setModalShow(false)}
        page={page}
        view={VIEW.add}
      />
    </div>
  );
};

export default DefaultMessage;
